import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useRecoilValue } from 'recoil';
import { useQueryClient } from '@tanstack/react-query';

import { requestApi } from 'api/Api';

import { pm } from 'lib/helpers/utility';

import { permissions } from 'components/state';
import { showAlert } from 'components/shared/Alert/Alert';
import Confirm from 'components/shared/Modal/Confirm/Confirm';
import Popover from 'components/shared/Popovers/Popover/Popover';

import ServiceModal from './ServiceModal';

const Actions = ({ data }) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const userPermissions = useRecoilValue(permissions);

  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const options = [
    ...(pm(userPermissions, 'services.update')
      ? [{ label: 'Edit', onClick: () => setShowEditModal(true), icon: 'edit-2-mono' }]
      : []),
    ...(pm(userPermissions, 'services.delete')
      ? [{ label: 'Delete', onClick: () => setShowDeleteModal(true), icon: 'trash-mono' }]
      : [])
  ];

  const handleDelete = async (service) => {
    const onSuccess = () => {
      queryClient.invalidateQueries({
        predicate: (query) => {
          return query.queryKey[0] === 'services';
        },
        refetchType: 'all'
      });

      showAlert({
        title: 'Service deletion',
        message: 'Service deleted',
        color: 'success'
      });

      setShowDeleteModal(false);
    };

    const onError = (error, code) => {
      if (code === 2)
        showAlert({
          title: 'No permission',
          message: "You're not authorized to delete services",
          color: 'danger'
        });
    };

    await requestApi({
      url: '/api/practice/services/delete',
      params: {
        serviceId: service.id
      },
      navigate,
      onError,
      onSuccess
    });
  };

  const onEditModalToggle = () => {
    setShowEditModal((prev) => !prev);
  };

  return (
    <div className="flex h-full items-center justify-center">
      <Popover
        className="flex h-full w-full items-center justify-center"
        position="left"
        isFixed
        icon="context-menu-horizontal"
        options={options}
        isBorder={false}
      />
      {showEditModal && (
        <ServiceModal item={data} isOpen={showEditModal} handleClose={onEditModalToggle} />
      )}
      {showDeleteModal && (
        <Confirm
          variant="danger"
          title="Delete service"
          icon="calendar-remove-mono"
          message="Are you sure you want to delete this service?"
          handleOpen={showDeleteModal}
          handleClose={() => setShowDeleteModal(false)}
          footerActions={{
            primary: {
              text: 'Yes, delete service',
              onClick: () => handleDelete(data),
              color: 'danger'
            }
          }}
        />
      )}
    </div>
  );
};

export default Actions;
